import { gql } from "apollo-boost"

export const getDasboardMonitoring = gql`
  {
  DashboardMonitoring(state:PROJECT, status:[AWAITING_INFO, INFO_SENT, ON_MONITORING, MONITORING_CONCLUDED,PAID]){
    id
    name
    agreementNumber
    approved
    difference
    budgeted
    region
    assignedTechnicalMonitor
    assignedFinancialMonitor
    implementer{
      name
    }
    invoices{
      amount
    }
    ministrationPlan{
      ministrationPeriods{
        ministrationDueDate
        ministrationStartDate
        ministrationEndDate
        orderIndex
        revisionDueDate
        revisionEndDate
				ministration{
          totalSupplied
          paymentDate
          totalSaved
          paymentAmount
          paymentBreakdown
          suppliedBreakdown
          savedBreakdown
        }
        ministrationBudget{
          ficosec
        }
      }
      monthlyReviewDueDate
    }
  }
  Visits:ALLFieldVisitsAndDeliverablesQuery{
    typeVisit
    date
    submissionId:id
  }
}
`